import PropTypes from 'prop-types';
import React from 'react';
import MatrixRowOther from '../shared/MatrixRowOther';
import SurveyAttachment from '../attachment/SurveyAttachment';
import classnames from 'classnames';

export const Table = ({ children }) => {
  return(
    <table className="srv-q-mtx mb6">{children}</table>
  )
};

Table.propTypes = {
  children: PropTypes.node,
};

export const Head = ({ children }) => (
  <thead>
    <tr>
      <th />
      {children}
    </tr>
  </thead>
);

Head.propTypes = {
  children: PropTypes.node,
};

export const Body = ({ children }) => <tbody>{children}</tbody>;

Body.propTypes = {
  children: PropTypes.node,
};

export const Row = ({ children, className = '', height, ...rest }) => {
  return(
    <tr className={`chc_grp ${className}`} style={{height: `${height}`}}>
      <RowHeader {...rest} />
        {children}
      <RowFooter {...rest} />
    </tr>
  )
};

Row.propTypes = {
  children: PropTypes.node,
};

export const RowHeader = ({
  based_on,
  id,
  other,
  questionId,
  questionName,
  text,
}) => {
  if (other) {
    return (
      <th
        className="fs-12 fw-n"
        style={{ maxWidth: '200px', paddingRight: '22px' }}
      >
        {!!id && <SurveyAttachment id={id} inlineVideo={false} />}
        <label aria-label="Other response" className="fs-12">
          <span
            className="other_txt tt-c desc-vert-rhythm"
            dangerouslySetInnerHTML={{ __html: text }}
          />
          <MatrixRowOther questionId={questionId} questionName={questionName} />
        </label>
      </th>
    );
  } else {
    return (
      <th
        className="fs-12 fw-n"
        style={{ maxWidth: '200px', paddingRight: '22px' }}
      >
        <SurveyAttachment id={id} inlineVideo={false} />
        <span
          className={classnames('desc-vert-rhythm', { 'based-on': based_on })}
          dangerouslySetInnerHTML={{ __html: text }}
        />
      </th>
    );
  }
};

RowHeader.propTypes = {
  id: PropTypes.string.isRequired,
  other: PropTypes.bool,
  questionId: PropTypes.string.isRequired,
  questionName: PropTypes.string,
  text: PropTypes.string,
};

export const RowFooter = ({
  based_on,
  id,
  comparison_text,
  bipolar,
}) => {
  if (comparison_text && bipolar) {
    return (
      <th
        className="fs-12 fw-n"
        style={{ maxWidth: '200px', paddingLeft: '62px' }}
      >
        <SurveyAttachment id={id} inlineVideo={false} />
        <span
          className={classnames('desc-vert-rhythm', { 'based-on': based_on })}
          dangerouslySetInnerHTML={{ __html: comparison_text}}
        />
      </th>
    );
  }
  else {
    return (<th></th>);
  }
};

RowFooter.propTypes = {
  id: PropTypes.string.isRequired,
  bipolar: PropTypes.bool,
  text: PropTypes.string,
  comparison_text: PropTypes.string,
};

export const Footer = ({ children }) => <tfoot>{children}</tfoot>;

Footer.propTypes = {
  children: PropTypes.node,
};

export const cellWidth = numRows => {
  const factor = 1.5;
  const width = 1 / numRows / factor * 100;
  return `${width}%`;
};
